import axios from "axios";

export async function login(email, password) {
  const response = await axios.post(`${API_URL}/auth/login`, {
    email,
    password,
  });
  const { token, user, expiresIn } = response.data;
  return { token, user, expiresIn };
}

export function logout(token) {
  return axios.post(
    `${API_URL}/auth/logout`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
}
